var ProcessSeriesData = function (result) {

    var series = [];
    var seriesValues = [];

    _.mapObject(result, function(val, key) {

        seriesValues = [];
        var valueFromKey = key;
        var valueArray = val;

        for (var k = 0; k < Object.keys(valueArray).length; k++) {
            seriesValues.push(valueArray[k].seriesKey);
        }

        series.push({
            "name": valueFromKey,
            "data": seriesValues
        });
    });

    return series;
}

exports.ProcessSeriesData=ProcessSeriesData;



//////////////////
// WEBPACK FOOTER
// ./src/modules/ProcessSeriesData/ProcessSeriesData.js
// module id = 14
// module chunks = 0